import { MinimumStationsGroup, Station } from '../../domain/stations';
import { BaseAPIClient } from '../base-api-client';

export const StationsAPI = {
  fetchAll(this: BaseAPIClient): Promise<Station[]> {
    return this.get('/stations');
  },

  /** Updates a station by id or slug and returns the saved station. */
  save(this: BaseAPIClient, idOrSlug: string, data: Partial<Station>): Promise<Station> {
    return this.put<Station>(`/stations/${idOrSlug}`, data);
  },

  fetchStationGroupsForStation(
    this: BaseAPIClient,
    idOrSlug: string,
  ): Promise<MinimumStationsGroup[]> {
    return this.get(`/stations-groups/stations/${idOrSlug}`);
  },

  fetchAllStationGroups(this: BaseAPIClient): Promise<MinimumStationsGroup[]> {
    return this.get('/stations-groups');
  },
};
